module.exports = __webpack_public_path__ + "static/media/budget.b357b4f9.svg";